import clientAxios from "../config";

const getAllUserRoutes = async (token) => clientAxios('/api/user-routes', {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getAllUserRoutesType = async (token, type) => clientAxios(`/api/user-route/type/${type}`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const validateRoute = async (token, data) => clientAxios.post('/api/user-route/path', data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getUserById = async (token, id) => clientAxios(`/api/user/${id}`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getUserByUuId = async (token, uuid) => clientAxios(`/api/user-uuid/${uuid}`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getAllUsers = async (token, rowsPerPage, page, userSearch, filters = {}) => {
    let url = `/api/users/${rowsPerPage}${userSearch && `/${userSearch}`}?page=${page}`;
    if (filters?.role_id) url += `&role_id=${filters.role_id}`;
    if (filters?.company_id) url += `&company_id=${filters.company_id}`;
    return clientAxios(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};
const createUser = async (token, data) => clientAxios.post(`/api/user`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const updateUser = async (token, id, data) => clientAxios.put(`/api/user/${id}`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});
const getAllUsersAvatars = async (token) => clientAxios(`/api/users-avatars`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

/**
 * Lista las empresas activas (rol Empresa) en payload mínimo:
 * id, uuid, name, email, phone, document, document_type_id.
 * Usado por selectors del front (p.ej. wizard de Agreements).
 */
const getCompanies = async (token) => clientAxios(`/api/users-companies`, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

/**
 * Buscador de usuarios "entregables" (no-empresa) para la página de Entregar
 * jugadas. Solo admin. Filtra por nombre/apellido/documento/email.
 */
const getDeliverableUsers = async (token, search = '') => clientAxios(`/api/users-deliverable`, {
    params: { search },
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

/**
 * Auto-desactivación de la cuenta del usuario autenticado.
 * Requiere la contraseña actual como segundo factor. Tras el éxito el
 * backend revoca todos los tokens de Sanctum del usuario, así que el
 * próximo request caerá con 401 (flujo de "sesión expirada").
 */
const selfDisableAccount = async (token, password) => clientAxios.post(
    `/api/user-self-disable`,
    { password },
    { headers: { Authorization: `Bearer ${token}` } },
);

export {
    getAllUserRoutes,
    validateRoute,
    getUserById,
    createUser,
    updateUser,
    getAllUsers,
    getAllUsersAvatars,
    getUserByUuId,
    getAllUserRoutesType,
    getCompanies,
    getDeliverableUsers,
    selfDisableAccount,
}